import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { OrganisationService } from "../../services/organisation/organisation.service";
import { IsDirty } from "../../services/can-deactivate-guard/is-dirty.interface";
import { AlertBannerService, AlertType } from "../../lib/alert-banner";
import { PermissionsService } from "../../services/permissions/permissions.service";
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { PlanService } from 'src/app/services/plan-status/plan-status.service';
import {ActivatedRoute, Router} from "@angular/router";
import moment from 'moment';
import * as Cookies from 'js-cookie';

@Component({
  selector: 'app-account-management',
  templateUrl: './account-management.component.pug',
  styleUrls: ['./account-management.component.scss'],
  standalone: false
})
export class AccountManagementComponent implements OnInit, IsDirty {
  bsModalRef!: BsModalRef;
  selectedOrg: any;
  createdOrg: any;
  loading = false;
  orgLoaded = false;
  planLoaded = false;
  allowCreate = false;
  organisationTab = false;
  teamsTab = false;
  aiSettingsTab = false;
  userManagementTab = false;
  referenceTab = false;
  exitTab = false;
  pulseTab = false;
  trustMarketplaceTab = false;
  requestTemplatesTab = false;
  xrefApiTab = false;
  canManageTemplate = false;
  organisationTabNew = false;
  usersTabNew = false;
  showReferenceTab = false;
  showExitTab = false;
  showUsersTab = false;
  showOrganisationTab = false;
  globalTab = false;
  showTeamsTab = false;
  showPulseTab = false;
  showTrustMarketplaceTab = false;
  currentOrg: any;
  currentPlan: any;
  expiryDate: any;
  defaultLogo = ConstantsService.DEFAULT_LOGO;
  requestAccess = $localize`Request Access`;
  requestAccessSubHeading = $localize`Access this page upon being granted permission.`;
  isOrgData = false;
  userRole: any = {}
  roles = ['member', 'member (restricted)', 'billing'];
  selectedTab = 'organisation'
  errorMap = new Map([
    ["brand_name", new Map([["duplicate", $localize`An organisation with this name already exists, please contact support@xref.com.`]])]
  ]);

  // Localized titles for navigation
  sidebarNavigationTitles = {
    organisationAndBrand: $localize`Organisation and brand`,
    users: $localize`Users`,
    teams: $localize`Teams`,
    reference: $localize`Reference`,
    pulse: $localize`Pulse`,
    exit: $localize`Exit`,
    requestTemplates: $localize`Packages`,
    trustMarketplace: $localize`Trust Marketplace`,
    aiSettings: $localize`AI settings`,
    xrefApi: $localize`Xref API`,
  };

  canViewOrgAndBrand = false;
  canViewAISettings = false;
  canSetReferenceSettings = false;
  canSetPulseSettings = false;
  canSetExitSettings = false;
  canSetTrustMarketplaceSettings = false;
  canManageUsers = false;
  canManageTeams = false;
  requestAccessReference = false;
  requestAccessExit = false;
  requestAccessPulse = false;
  requestAccessTmp = false;
  managePermissions = false;
  managePermissionsUser:any = "";
  memberAdministratorPermissions:any = {};

  constructor(
    private modalService: BsModalService,
    private organisationService: OrganisationService,
    private alertList: AlertBannerService,
    private permissions: PermissionsService,
    private planService: PlanService,
    private activeRoute: ActivatedRoute,
    private router: Router
  ) {
  }

  get canViewXrefApi(): boolean {
    return this.permissions?.data?.['role']?.['role'] === 'owner'
      && this.permissions.isFeatureActivated('xref-api-v1');
  }

  ngOnInit(): void {
    this.canViewOrgAndBrand = this.permissions.hasPermission("can_view_organisation_and_brand")
    if (this.canViewOrgAndBrand) this.organisationTabNew = true;
    this.canViewAISettings = this.permissions.hasPermission("can_set_ai_settings") ||
      this.permissions.hasPermission("can_set_pulse_ai_settings")
    this.canSetReferenceSettings = this.permissions.hasPermission("can_set_reference_settings")
    this.canSetPulseSettings = this.permissions.hasPermission("can_set_pulse_settings")
    this.canSetExitSettings = this.permissions.hasPermission("can_set_exit_settings")
    this.canSetTrustMarketplaceSettings = this.permissions.hasPermission("can_set_trust_settings")
    this.canManageTemplate = this.permissions.hasPermission("can_manage_package") ||
        this.permissions.hasPermission("can_manage_reference_package") ||
        this.permissions.hasPermission("can_manage_backgroundcheck_package")
    this.canManageUsers = this.permissions.hasPermission("can_manage_reference_invitees_and_users") ||
                          this.permissions.hasPermission("can_manage_exit_invitees_and_users") ||
                          this.permissions.hasPermission("can_manage_pulse_invitees_and_users") ||
                          this.permissions.hasPermission("can_manage_backgroundcheck_invitees_and_users")
    if (this.canManageUsers) {
      this.usersTabNew = !this.organisationTabNew;
    }
    if (!this.canManageUsers) {
      this.router.navigate(['/no-access']);
    }
    this.canManageTeams = this.permissions.hasPermission("can_manage_teams")
    if (this.canManageTeams) {
      this.teamsTab = !(this.organisationTabNew || this.usersTabNew);
    }
    if (this.permissions.hasUserOrgPermission('create_organisation')) {
      this.allowCreate = true;
    }
    this.loading = true;
    this.organisationService.getOrganisation().subscribe(
      res => {
        this.currentOrg = res;
        this.getUserPermissionsForOrg();
        this.orgLoaded = true;
        this.checkLoadingComplete();
      },
      () => {
        this.orgLoaded = true;
        this.loading = false;
      }
    );


    this.getPlanStatus();

    this.managePermissions = this.activeRoute.snapshot.queryParams['managePermissions'];
    this.managePermissionsUser = this.activeRoute.snapshot.queryParams['user'];
    if(this.managePermissions) {
      let newOrgUid = this.activeRoute.snapshot?.queryParams['org_uid'];
      let savedOrgUid = Cookies.get(ConstantsService.ORG_COOKIE);
      if(newOrgUid && newOrgUid !== savedOrgUid){
        this.organisationService.setSwitchOrg(true);
      }
      this.goToSettings('userManagement');
    }
    else {
        // Check for tab query parameter to open specific tab
        const tab = this.activeRoute.snapshot.queryParams['tab'];
        if (tab === 'requestTemplates') {
          this.goToSettings('requestTemplates');
        }
      }
  }

  private checkLoadingComplete() {
    if (this.orgLoaded && this.planLoaded) {
      this.loading = false;
    }
  }

  private getUserPermissionsForOrg() {
    if (this.currentOrg !== undefined) {
      const success = () => {
        this.permissions.updateAccManagementPermissionSubject(true);
        if (!this.roles.includes(this.permissions.userRole)) {
          this.showReferenceTab = true;
          this.showExitTab = true;
          this.showTrustMarketplaceTab = true;
          this.showUsersTab = true;
          this.showOrganisationTab = true;
          this.showTeamsTab = true;
          this.organisationTab = true;
          this.showPulseTab = true;
          this.isOrgData = true;
        }
        else {
          this.showUsersTab = true;
          this.userManagementTab = true;
          this.isOrgData = true;
        }
      }
      const error = () => {
        console.log(error);
        this.isOrgData = false;
        this.loading = false;
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
      this.permissions.initializeAccManagementPermissions(this.currentOrg.uid).subscribe(success, error);
    }
  }

  isDirty(): boolean {
    return this.bsModalRef && 'isDirty' in this.bsModalRef.content && this.bsModalRef.content.isDirty();
  }
  checkOverflow(element: any): boolean {
   return element.scrollHeight > element.clientHeight || element.offsetWidth < element.scrollWidth
  }

  switchOrg(org) {
    this.selectedOrg = org;
  }
  goToSettings(data) {
    window.scrollTo(0, 0);
    this.organisationTab = false;
    this.userManagementTab = false;
    this.teamsTab = false;
    this.aiSettingsTab = false;
    this.referenceTab = false;
    this.exitTab = false;
    this.pulseTab = false;
    this.trustMarketplaceTab = false;
    this.requestTemplatesTab = false;
    this.xrefApiTab = false;
    this.globalTab = false;
    this.usersTabNew = false;
    this.organisationTabNew = false;
    this.requestAccessReference = false;
    this.requestAccessExit = false;
    this.requestAccessPulse = false;
    this.requestAccessTmp = false;
    switch (data) {
      case 'organisation':
        this.organisationTabNew = true;
        if (!this.canViewOrgAndBrand) {
          this.globalTab = true;
        }
        break;
      case 'reference':
        if (this.canSetReferenceSettings) {
          this.referenceTab = true;
        } else {
          this.requestAccessReference = true;
          this.globalTab = true;
        }
        break;
      case 'exit':
        if (this.canSetExitSettings) {
          this.exitTab = true;
        } else {
          this.requestAccessExit = true;
          this.globalTab = true;
        }
        break;
      case 'pulse':
        if (this.canSetPulseSettings) {
          this.pulseTab = true;
        } else {
          this.requestAccessPulse = true;
          this.globalTab = true;
        }
        break;
      case 'trustMarketplace':
        if (this.canSetTrustMarketplaceSettings) {
          this.trustMarketplaceTab = true;
        } else {
          this.requestAccessTmp = true;
          this.globalTab = true;
        }
        break;
      case 'userManagement':
        this.usersTabNew = true;
        break;
      case 'teams':
        this.teamsTab = true;
        break;
      case 'aiSettings':
        if (this.canViewAISettings) {
          this.aiSettingsTab = true;
        } else {
          this.globalTab = true;
        }
        break;
      case 'requestTemplates':
        if (this.canManageTemplate) {
          this.requestTemplatesTab = true;
        } else {
          this.globalTab = true;
        }
        break;
      case 'xrefApi':
        if (this.canViewXrefApi) {
          this.xrefApiTab = true;
        } else {
          this.globalTab = true;
        }
        break;
    }

  }

  getPlanStatus() {
    this.planService.getPlan('sum').subscribe(res => {
      if (res.message != 'No plans found') {
        this.currentPlan = res['data']['object'];
        this.currentPlan.expirydate = moment(this.currentPlan.furthest_valid_date).local().format('ll');
        this.expiryDate = moment.utc(this.currentPlan.valid_to).format('YYYY-MM-DD HH:mm:ss');
        const startDate = moment.utc(this.currentPlan.valid_from).format('YYYY-MM-DD HH:mm:ss');
        this.currentPlan.currentdate = moment.utc(new Date()).format('YYYY-MM-DD HH:mm:ss');
        if (this.currentPlan.currentdate > this.expiryDate) {
          this.currentPlan.expirydate = "Expired";
        } else if (this.currentPlan.currentdate < startDate || this.currentPlan.active === false || this.currentPlan.payment_status === 2) {
          this.currentPlan.expirydate = moment(this.currentPlan.valid_to).local().format('ll');
        }
      } else {
        this.currentPlan = null;
      }
      this.planLoaded = true;
      this.checkLoadingComplete();
    },
      (err: any) => {
        this.currentPlan = null;
        this.planLoaded = true;
        this.checkLoadingComplete();
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
  }

  onRequestAccess(){
    let product = '';
    if(this.requestAccessExit){
      product = 'Exit';
    }
    if(this.requestAccessReference){
      product = 'Reference';
    }
    if(this.requestAccessPulse){
      product = 'Pulse';
    }
    if(this.requestAccessTmp){
      product = "Background check";
    }
    if (product == 'Reference' || product == 'Exit' || product == 'Pulse' || product == "Background check") {
      this.permissions.requestAccess(
      {
        product: product,
        template_type: 'hybrid'
      }
    ).subscribe(
      (res) => {
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Your request has been sent successfully. You will be notified once your request has been approved.`,
          keepOnRouteChange: true
        }]);
      },
      (error) => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    )
    }
  }
}
